import React, { useState, useRef, useEffect } from "react";
import { UploaderScroller } from "./UploaderScroller.js";
import "./EmbedLogoUploader.scss";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import AvatarEditor from "react-avatar-editor";

const _URL = window.URL || window.webkitURL;

const EmbedLogoSelector = React.forwardRef(
  (
    {
      image,
      handleClick,
      imageSizes,
      setImageSizes,
      cancelImage,
      handleNewImage,
      error,
    },
    ref
  ) => {
    const { getHtmlByKey, getTextByKey } = useContent();

    const inputRef = useRef();

    //scroller scaling logic
    const [scale, setScale] = useState(1);
    const handleScale = (e) => {
      const scale = parseFloat(e.target.value);
      setScale(scale);
    };

    useEffect(() => {
      if (image) {
        const img = new Image();
        img.onload = function () {
          setImageSizes(() => ({
            valid: this.width > 30 && this.height > 30,
            width:
              this.width > 250
                ? this.width > this.height
                  ? 250
                  : 250 * (this.width / this.height)
                : this.height > 250
                ? 250 * (this.width / this.height)
                : this.width,
            height:
              this.height > 250
                ? this.height > this.width
                  ? 250
                  : 250 * (this.height / this.width)
                : this.width > 250
                ? 250 * (this.height / this.width)
                : this.height,
          }));
        };
        if (typeof image !== "string") {
          const url = _URL.createObjectURL(image);
          img.src = url;
        } else {
          img.src = image;
        }
      }
    }, [image]);

    return (
      <div className={`logo-selector ${image ? "selector-with-picture" : ""}`}>
        <div
          className={`logo-picture ${image ? "with-picture" : ""}`}
          style={
            !image || !imageSizes.valid
              ? {
                  height: `${320}px`,
                  width: `${320}px`,
                }
              : { height: imageSizes.height + 120 }
          }
        >
          {image && (
            <div className="actions">
              <div
                className="delete-image"
                onClick={() => cancelImage({ ifClose: false, ifRemove: true })}
              >
                <Icon name="trash-solid" />
              </div>
              <div className="upload-image" onClick={handleClick}>
                <Icon name="camera" />
              </div>
            </div>
          )}
          <div
            className={`logo-selector-center ${
              image ? "logo-image-selected" : ""
            }`}
            style={
              !image || !imageSizes.valid
                ? {
                    height: `${250}px`,
                  }
                : { height: imageSizes.height + 10 }
            }
          >
            {(image && !imageSizes.valid) || error ? (
              <div className="validation-size-container">
                {error
                  ? getHtmlByKey(error)
                  : getTextByKey("embed-logo-min-size")}
              </div>
            ) : null}
            {image ? (
              <AvatarEditor
                ref={ref}
                image={image}
                width={Math.round(imageSizes.width)}
                height={Math.round(imageSizes.height)}
                crossOrigin=""
                border={0}
                color={[255, 255, 255, 0.6]} // RGBA
                scale={parseFloat(scale)}
                rotate={0}
              />
            ) : (
              <div className="click-to-action-circle">
                <Icon name="cloud-upload" white></Icon>
                <span>
                  {getTextByKey("personal-pages-upload-image-button")}
                </span>
                <input
                  accept="image/*"
                  className="click-to-action-upload-input embed-logo-upload-input"
                  name="newImage"
                  type="file"
                  onChange={handleNewImage}
                  ref={inputRef}
                ></input>
              </div>
            )}
          </div>
          {/* <div className={`logo-selector-bottom`}>
            <Image src={bottomImage} title="" alt="" />
          </div> */}
        </div>
        {image && imageSizes.width > 50 && image.indexOf("https://") < 0 ? (
          <UploaderScroller
            image={image}
            handleScale={handleScale}
            maxValue={imageSizes.width / 50}
          />
        ) : null}
      </div>
    );
  }
);

export default EmbedLogoSelector;
